import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { UserLoggedInNavigatorParamList } from "../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";

export const WAFileStackNavigator =
  createNativeStackNavigator<WAFileStackParamList>();
type WAFileStackParamList = {
  WAFileMain: {
    fileIds: string[];
    slideshowDuration: number;
  } & UserLoggedInNavigatorParamList["WidgetAddFile"];
  WAFileSelect: {
    fileIds: string[];
    slideshowDuration: number;
  } & UserLoggedInNavigatorParamList["WidgetAddFile"];
  WAAllFileSelect: {
    fileIds: string[];
    slideshowDuration: number;
  } & UserLoggedInNavigatorParamList["WidgetAddFile"];
};
export type WAFileRouteProp<T extends keyof WAFileStackParamList> = RouteProp<
  WAFileStackParamList,
  T
>;

export type WAFileNavigationProp<T extends keyof WAFileStackParamList> =
  CompositeNavigationProp<
    NativeStackNavigationProp<WAFileStackParamList, T>,
    NativeStackNavigationProp<UserLoggedInNavigatorParamList>
  >;
